// Данный стор используется только на клиенте
import { ExampleStore } from "./example";

class RootStore {
  example: ExampleStore;

  constructor() {
    this.example = new ExampleStore();
  }
}

export default RootStore;

let store: RootStore;

// Функция для создания Singleton стора
export const initializeStore = (): RootStore => {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
  const _store = store ?? new RootStore();

  if (!store) store = _store;

  return store;
};
